import { render } from "./alltotalList.vue?vue&type=template&id=8966d28e&scoped=true"
import script from "./alltotalList.vue?vue&type=script&lang=js"
export * from "./alltotalList.vue?vue&type=script&lang=js"

import "./alltotalList.vue?vue&type=style&index=0&id=8966d28e&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8966d28e"]])

export default __exports__